/** @format */

import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    standalone: false,
    selector: "app-recipient-card",
    templateUrl: "./recipient-card.component.html",
    styleUrls: ["./recipient-card.component.css"],
})
export class RecipientCardComponent {
    @Input() cardId = "";
    @Input() title = "";
    @Input() subtitle = "";
    @Input() expanded = false;

    @Input() appUserSelected = false;
    @Input() uploadedRefFileSelected = false;

    @Input() users: any[] = [];
    @Input() selectedUsers: any[] = [];

    @Input() uploadedFileName = "";
    @Input() uploadProgress = 0;
    @Input() uploadStatus: "idle" | "uploading" | "complete" | "error" = "idle";
    @Input() showUploadStatus = false;
    @Input() csvValidated = false;
    @Input() validationMessage = "";

    @Output() toggleExpanded = new EventEmitter<void>();
    @Output() appUserToggle = new EventEmitter<void>();
    @Output() refFileToggle = new EventEmitter<void>();
    @Output() selectionChange = new EventEmitter<any[]>();
    @Output() fileSelected = new EventEmitter<Event>();
    @Output() downloadSample = new EventEmitter<void>();
}
